import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WebshopState } from '../reducers/webshop.reducer';
import { StateProperty } from '../reducers';
import { Webshop } from '@models/webshop.model';

export const webshopsSelector = createFeatureSelector<WebshopState>(StateProperty.WEBSHOPS);

export const selectWebshops = createSelector(
  webshopsSelector,
  state => state.webshops
);

export const selectSelectedWebshopId = createSelector(
  webshopsSelector,
  state => state.selectedWebshopId
);

export const selectFilteredWebshops = createSelector(
  selectWebshops,
  selectSelectedWebshopId,
  (webshops, selectedId) => {
    if (selectedId) {
      return webshops.filter(w => w.id === selectedId);
    }
    return webshops;
  }
);

export const selectWebshopIsLoading = createSelector(
  webshopsSelector,
  state => state.isLoading
);

export const selectSelectedWebshop = createSelector(
  selectWebshops,
  selectSelectedWebshopId,
  (webshops, selectedId) => webshops?.find(w => w.id === selectedId)
);

export const selectWebshop = createSelector(
  webshopsSelector,
  (state: WebshopState) => state.detail
);

export const selectActiveWebshop = createSelector(
  selectSelectedWebshop,
  selectWebshop,
  (selected, detail) => selected || detail
);

export const webshopFilter = (webshops: Webshop[], searchValue: string): Webshop[] => {
  if (searchValue?.trim().length < 1 || searchValue === '') {
    return webshops;
  }
  return webshops.filter(webshop => searchCaseInsensitive(webshop.name, searchValue) || searchCaseInsensitive(webshop.id ?? '', searchValue) || searchCaseInsensitive(webshop.chamberOfCommerce.toString(), searchValue))
}

export const searchCaseInsensitive = (field: string, searchValue: string) => {
  return field !== undefined && field.toLowerCase().indexOf(searchValue?.toLowerCase()) >= 0
}

